module.exports = __webpack_public_path__ + "img/icon-nav-arrow-left.406264b8.svg";